import { GetReviewFormsResponseJson } from "@performyard/service-contracts";

import { PYUseQueryOptions } from "../../hooks/StandardQueryArguments";

import { getAllReviewForms } from "../../services/defs/internal-api/review-forms";

export const allReviewFormsQuery = (options?: PYUseQueryOptions<GetReviewFormsResponseJson>) => ({
	queryKey: ["all-review-forms"],
	queryFn: () => getAllReviewForms(),
	meta: {
		errorMessage: "There was an error getting the review forms.",
	},
	...options,
});
